import React from "react";
import { Layout } from "antd";
import WebsiteIndexEntryTabs from "../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs";
import TrackedKeywordsCount from "../TrackedKeywordsCount";
import TrackedKeywordsOverview from "../TrackedKeywordsOverview";


export default function KeywordPositionPage() {
    return (
        <Layout.Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <TrackedKeywordsCount />
                <TrackedKeywordsOverview />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
